import React, { useEffect, useState, useMemo } from 'react';
import api from '~/services/api';
import HandleFormData from '~/utils/HandleFormData';
import { Label, Input, Select, TextArea } from '~/componentes/CustomForm';
import ColoredFileInput from '~/componentes/CustomForm/FileInput/styles/ColoredFileInput';

import {
  CardContainerInput,
  Container,
  DistribuicaoEHorasContainer,
  FinanceResultContainer,
  AnalistasTable,
  AnalistasTableHeader,
  AnalistasTableBody,
} from './styles';
import { Materialize } from '~/styles/materializeGrid';
import ShowConfirmacao from '~/utils/ShowConfirmacao';
import RecursosList from './RecursosList';
import PrioridadeListColor from './PrioridadeListColor';
import AtividadesList from './AtividadesList';
import AcessosList from './AcessosList';
import FinanceChart from './FinanceChart';
import { Colors } from '~/config/Colors';
import Tooltip from '~/componentes/Tooltip';
import { StatusCard } from '~/componentes/StatusCard';

function CreateEditContent({ mountedData }) {
  const [abaAtiva, setAbaAtiva] = useState(0);
  const abas = [
    { titulo: 'Projeto' },
    { titulo: 'Planejado' },
    { titulo: 'Executado' },
    { titulo: 'Processos' },
    { titulo: 'Acessos' },
  ];

  const [etapas, setEtapas] = useState([]);
  const [etapasFluxo, setEtapasFluxo] = useState([]);
  const [contratos, setContratos] = useState([]);
  const [clientes, setClientes] = useState([]);
  const [cliente, setCliente] = useState(mountedData ? mountedData?.cliente : {});
  const [solicitantes, setSolicitantes] = useState([]);
  const [coordenadores, setCoordenadores] = useState([]);
  const [produtos, setProdutos] = useState([]);
  const [recursos, setRecursos] = useState([]);
  const [atividades, setAtividades] = useState([]);
  const [acessos, setAcessos] = useState([]);
  const [prioridade, setPrioridade] = useState({});
  const [idEtapa, setIdEtapa] = useState(mountedData ? mountedData?.idEtapa : 1);
  const [idEtapaFluxo, setIdEtapaFluxo] = useState(mountedData ? mountedData?.idEtapaFluxo : 0);
  const [horaTotal, setHoraTotal] = useState(mountedData ? mountedData?.horaTotal : 0);
  const [horaSaldo, setHoraSaldo] = useState(mountedData ? mountedData?.horaSaldo : 0);
  const [horaUsada, setHoraUsada] = useState(mountedData ? mountedData?.horaUsada : 0);
  const [gerarProjeto, setGerarProjeto] = useState(false);
  const [removeArquivos, setRemoveArquivos] = React.useState([]);
  const [file1, setFile1] = useState();
  const [file2, setFile2] = useState();
  const [file3, setFile3] = useState();
  const [file4, setFile4] = useState();
  const [ativo, setAtivo] = useState(!mountedData ? 'true' : mountedData?.ativo ? 'true' : 'false');
  const [valorHoraBruto, setValorHoraBruto] = useState(mountedData?.valorHora || 0);
  const [valorHoraLiquido, setValorHoraLiquido] = useState(mountedData?.valorHoraLiquido || 0);
  const [horaLevantamento, setHoraLevantamento] = useState(mountedData?.horaLevantamento || 0);
  const [valorTotalBruto, setValorTotalBruto] = useState(mountedData?.valorTotal || 0);
  const [valorTotalLiquido, setValorTotalLiquido] = useState(mountedData?.valorTotalLiquido || 0);
  const [margemLucro, setMargemLucro] = useState(mountedData?.margemLucro || 0);
  const [valorOrcamento, setValorOrcamento] = useState(mountedData?.valorOrcamento || 0);
  const [horasPrevistaDev, setHorasPrevistaDev] = useState(mountedData?.horasPrevistaDev || 0);
  const [valorMediaAna, setValorMediaAna] = useState(mountedData?.valorMediaAna || 0);
  const [valorImposto, setValorImposto] = useState(mountedData?.valorImposto || 0);
  const [percentualImposto, setPercentualImposto] = useState(mountedData?.percentualImposto || 0);
  const [percentualLucro, setPercentualLucro] = useState(mountedData?.percentualLucro || 0);
  const [percentualGP, setPercentualGP] = useState(mountedData?.percentualGP || 0);
  const [horasGP, setHorasGP] = useState(mountedData?.horasGP || 0);
  const [horasDev, setHorasDev] = useState(mountedData?.horasDev || 0);

  const [percentualMaoObra, setPercentualMaoObra] = useState(
    mountedData?.calculoHoras?.percentualMaoObra || 0.5,
  );
  const [valorNivel1, setValorNivel1] = useState(mountedData?.calculoHoras?.valorNivel1 || 40.0);
  const [valorNivel2, setValorNivel2] = useState(mountedData?.calculoHoras?.valorNivel2 || 50.0);
  const [valorNivel3, setValorNivel3] = useState(mountedData?.calculoHoras?.valorNivel3 || 60.0);
  const [valorCoordenacao, setValorCoordenacao] = useState(
    mountedData?.calculoHoras?.valorCoordenacao || 60.0,
  );
  const [horasCoordenacao, setHorasCoordenacao] = useState(
    mountedData?.calculoHoras?.horasCoordenacao || 10,
  );
  const [valorMaoObra, setValorMaoObra] = useState(0);
  const [valorAposCoordenacao, setValorAposCoordenacao] = useState(0);
  const [horasNivel1, setHorasNivel1] = useState(0);
  const [horasNivel2, setHorasNivel2] = useState(0);
  const [horasNivel3, setHorasNivel3] = useState(0);

  function horaDecimalParaMinutos(valor) {
    const num = Number(valor) || 0;
    const horas = Math.trunc(num);
    const minutos = Math.round((num - horas) * 100);
    return horas * 60 + minutos;
  }

  function minutosParaMascara(minutos) {
    const h = Math.trunc(minutos / 60);
    const m = minutos % 60;
    return `${String(h).padStart(2, '0')}:${String(m).padStart(2, '0')}`;
  }

  const analistasConsolidados = useMemo(() => {
    if (!mountedData?.atividades || mountedData.atividades.length === 0) {
      return [];
    }

    const analistasMap = new Map();

    mountedData.atividades.forEach(atividade => {
      if (atividade.itensAtividade && atividade.itensAtividade.length > 0) {
        atividade.itensAtividade.forEach(item => {
          const key = item.idAnalista;

          if (!analistasMap.has(key)) {
            analistasMap.set(key, {
              idAnalista: item.idAnalista,
              nomeAnalista: item.analistaAtividade?.analista?.nome || 'N/A',
              idNivel: item.analistaAtividade?.analista?.idNivel ?? null,
              minutosUsados: 0,
              atividades: [],
            });
          }

          const analista = analistasMap.get(key);
          analista.minutosUsados += horaDecimalParaMinutos(item.horaUsadaRealOS);
          analista.atividades.push(atividade.titulo);
        });
      }
    });

    return Array.from(analistasMap.values()).map(analista => {
      const horasDecimal = analista.minutosUsados / 60;

      const nivelMap = {
        1: { nivel: 'Nível 1', valorHora: valorNivel1 },
        2: { nivel: 'Nível 2', valorHora: valorNivel2 },
        3: { nivel: 'Nível 3', valorHora: valorNivel3 },
      };
      const nivelInfo = nivelMap[analista.idNivel] || { nivel: 'N/A', valorHora: 0 };
      const { nivel, valorHora } = nivelInfo;

      const custo = valorHora * horasDecimal;

      return {
        ...analista,
        horaUsadaMascara: minutosParaMascara(analista.minutosUsados),
        horasDecimal,
        nivel,
        valorHora,
        custo,
      };
    });
  }, [mountedData?.atividades, valorNivel1, valorNivel2, valorNivel3]);

  useEffect(() => {
    if (mountedData) {
      setHoraTotal(mountedData?.horaTotal);
      setHoraSaldo(mountedData?.horaSaldo);
      api
        .get('/signed/empresa/gestorprojeto/etapa/etapas', { params: { ativo: 1, tipo: 'PRJ' } })
        .then(r => {
          setEtapas(r?.data);
          setIdEtapa(mountedData?.idEtapa);
        });

      api
        .get('/signed/empresa/gestorprojeto/etapa/etapas', { params: { ativo: 1, tipo: 'FPJ' } })
        .then(r => {
          setEtapasFluxo(r?.data);
          setIdEtapaFluxo(mountedData?.idEtapaFluxo);
        });
    } else {
      api
        .get('/signed/empresa/gestorprojeto/etapa/etapas', {
          params: { ativo: 1, tipo: 'PRJ', posicao: 1 },
        })
        .then(r => {
          setEtapas(r?.data);
          if (r?.data?.length > 0) {
            setIdEtapa(r?.data[0]?.id);
          }
        });
    }

    api
      .get('/signed/empresa/suporte/contratos', { params: { ativo: 1, listContrato: true } })
      .then(r => setContratos(r?.data));
    api
      .get('/signed/empresa/gestorprojeto/cliente/clientes', { params: { ativo: 1 } })
      .then(r => setClientes(r?.data));
    api
      .get('/signed/empresa/gestorprojeto/gerencia/coordenadores', { params: { ativo: 1 } })
      .then(r => setCoordenadores(r?.data));
    api
      .get('/signed/empresa/gestorprojeto/gerencia/produtos', { params: { ativo: 1 } })
      .then(r => setProdutos(r?.data));
  }, []);

  useEffect(() => {
    if (cliente?.id) {
      cliente?.id &&
        api
          .get('/signed/empresa/gestorprojeto/gerencia/clientesolicitantes', {
            params: { ativo: 1, idCliente: cliente?.id },
          })
          .then(r => setSolicitantes(r?.data));
    } else {
      setSolicitantes([]);
    }
  }, [cliente]);

  function calcularHorasNiveis() {
    if (valorTotalBruto > 0) {
      const valorBrutoProjeto = parseFloat(valorTotalBruto);
      const valorMaoObraCalculado = valorBrutoProjeto * percentualMaoObra;
      setValorMaoObra(valorMaoObraCalculado);
      const valorCoordenacaoTotal = horasCoordenacao * valorCoordenacao;
      const valorAposCoordenacaoCalculado = valorMaoObraCalculado - valorCoordenacaoTotal;
      setValorAposCoordenacao(valorAposCoordenacaoCalculado);

      if (valorAposCoordenacaoCalculado > 0) {
        const horasNivel1Calculadas = Math.floor(valorAposCoordenacaoCalculado / valorNivel1);
        const horasNivel2Calculadas = Math.floor(valorAposCoordenacaoCalculado / valorNivel2);
        const horasNivel3Calculadas = Math.floor(valorAposCoordenacaoCalculado / valorNivel3);

        setHorasNivel1(horasNivel1Calculadas);
        setHorasNivel2(horasNivel2Calculadas);
        setHorasNivel3(horasNivel3Calculadas);
      } else {
        setHorasNivel1(0);
        setHorasNivel2(0);
        setHorasNivel3(0);
      }
    } else {
      setValorMaoObra(0);
      setValorAposCoordenacao(0);
      setHorasNivel1(0);
      setHorasNivel2(0);
      setHorasNivel3(0);
    }
  }

  useEffect(() => {
    calcularHorasNiveis();
  }, [
    valorTotalBruto,
    percentualMaoObra,
    valorNivel1,
    valorNivel2,
    valorNivel3,
    valorCoordenacao,
    horasCoordenacao,
  ]);

  async function handleSubmit(data, options) {
    const { closeReload } = options || {};

    return ShowConfirmacao(
      async () => {
        let thisData = HandleFormData([file1, file2, file3, file4], {
          emailRespCliente: data?.emailRespCliente,
          horaTotal: data?.horaTotal,
          valorTotal: valorTotalBruto,
          valorHoraLiquido,
          horaLevantamento,
          valorHora: valorHoraBruto,
          valorTotalLiquido,
          margemLucro,
          valorOrcamento,
          horasPrevistaDev,
          valorMediaAna,
          valorImposto,
          percentualImposto,
          percentualLucro,
          percentualGP,
          horasGP,
          horasDev,
          idEtapaFluxo,
          exibeFluxo: data?.exibeFluxo,
          dataInicioProjeto: data?.dataInicioProjeto,
          dataPrevEntregaProjeto: data?.dataPrevEntregaProjeto,
          descricaoProjeto: data?.descricaoProjeto,
          idCoordenador: data?.idCoordenador,
          idCoordenadorTec: data?.idCoordenadorTec,
          idClienteSolicitante: data?.idClienteSolicitante,
          tipoProjeto: data?.tipoProjeto,
          ...(mountedData?.id ? { id: mountedData?.id } : {}),
          ativo: ativo === 'true' ? true : false,
          gerarProjeto,
          recursos,
          idEtapa,
          prioridade,
          atividades,
          acessos,
          removeArquivos,
          calculoHoras: {
            percentualMaoObra,
            valorNivel1,
            valorNivel2,
            valorNivel3,
            valorCoordenacao,
            horasCoordenacao,
          },
        });

        let response;
        if (mountedData?.id)
          response = await api.put('/signed/empresa/gestorprojeto/projeto', thisData);
        else response = await api.post('/signed/empresa/gestorprojeto/projeto', thisData);

        if (response?.status === 200) {
          closeReload && closeReload();
        }
        return response;
      },
      {
        errorModal: {
          defaultMessage: `Ocorreu um erro ao ${
            mountedData?.id ? 'atualizar' : 'cadastrar'
          } esse Projeto, por favor, tente novamente mais tarde.`,
        },
        message: `Tem certeza que deseja ${
          mountedData?.id ? 'atualizar' : 'cadastrar'
        } esse Projeto?`,
        successModal: `Projeto ${mountedData?.id ? 'atualizado' : 'cadastrado'} com sucesso!`,
      },
    );
  }

  console.log('mountedData', mountedData);
  return (
    <Container onSubmit={handleSubmit} noValidate defaultScroll={true}>
      <Materialize className="materialize">
        <div className="row header">
          {abas.map((thisVal, a) => (
            <div
              key={a}
              className={abaAtiva == a ? 'item-aba ativo' : 'item-aba'}
              onClick={() => setAbaAtiva(a)}
            >
              <span></span>
              <p>{thisVal?.titulo}</p>
            </div>
          ))}
        </div>

        {mountedData && (
          <div>
            <div className={abaAtiva == 0 ? 'item-modal ativo' : ' item-modal'}>
              <div className="row no-margin">
                <div className="col s6 m6 l6 no-padding">
                  <div className="row no-margin">
                    <Label title="Título *" className="col s8 m8 l8">
                      <Input
                        name="titulo"
                        disabled="true"
                        required="true"
                        defaultValue={mountedData?.titulo}
                      />
                    </Label>
                    <Label title="Data Solicitação *" className="col s4 m4 l4">
                      <Input
                        type="date"
                        disabled="true"
                        name="dataProjeto"
                        required="true"
                        defaultValue={mountedData?.dataProjeto}
                      />
                    </Label>
                  </div>
                  <div className="row no-margin">
                    <Label title="Cliente *" className="col s12 m4 l4">
                      <Select
                        required="true"
                        isString
                        list={{ list: clientes, value: 'id', label: 'nomeFantasia' }}
                        name="idCliente"
                        disabled="true"
                        firstOption
                        defaultValue={mountedData?.idCliente}
                        onChange={e => {
                          const v = e.currentTarget.value || 'true';
                          const cliente = clientes?.find(e => e?.id == parseInt(v));
                          setCliente(cliente || {});
                        }}
                      />
                    </Label>
                    <Label title="Solicitante Cliente *" className="col s12 m4 l4">
                      <Select
                        required="true"
                        isString
                        list={{ list: solicitantes, value: 'id', label: 'nome' }}
                        name="idClienteSolicitante"
                        firstOption
                        defaultValue={mountedData?.idClienteSolicitante}
                      />
                    </Label>
                    <Label title="Produto *" className="col s12 m4 l4">
                      <Select
                        required="true"
                        isString
                        disabled="true"
                        list={{ list: produtos, value: 'id', label: 'titulo' }}
                        name="idProduto"
                        firstOption
                        defaultValue={mountedData?.idProduto}
                      />
                    </Label>
                  </div>
                  <div className="row no-margin">
                    <Label title="Exibe no Fluxo *" className="col s12 m6 l3">
                      <Select
                        required="true"
                        isString
                        list={{
                          list: [
                            { id: 'S', titulo: 'Sim' },
                            { id: 'N', titulo: 'Não' },
                          ],
                          value: 'id',
                          label: 'titulo',
                        }}
                        name="exibeFluxo"
                        defaultValue={mountedData?.exibeFluxo}
                      />
                    </Label>
                    <Label title="Etapa Fluxo *" className="col s12 m6 l3">
                      <Select
                        required="true"
                        isString
                        list={{ list: etapasFluxo, value: 'id', label: 'titulo' }}
                        name="idEtapaFluxo"
                        defaultValue={idEtapaFluxo}
                        onChange={e => {
                          const v = e.currentTarget.value || 0;
                          setIdEtapaFluxo(v);
                        }}
                      />
                    </Label>
                  </div>
                  <div className="row no-margin">
                    <Label title="Descrição do Projeto" className="col s12 m12 l12">
                      <TextArea
                        name="descricaoProjeto"
                        defaultValue={mountedData?.descricaoProjeto}
                      />
                    </Label>
                    {/* <Label title="Contrato" className="col s12 m6 l4">
                        <Select
                          isString
                          list={{ list: contratos, value: "id", label: "titulo" }}
                          name="idContrato"
                          firstOption
                          defaultValue={mountedData?.idContrato}
                        />
                      </Label> */}
                  </div>
                </div>
                <div className="col s6 m6 l6 no-padding">
                  <div className="row no-margin">
                    <Label title="Envia Email *" className="col s12 m6 l3">
                      <Select
                        required="true"
                        isString
                        list={{
                          list: [
                            { id: 'S', titulo: 'Sim' },
                            { id: 'N', titulo: 'Não' },
                          ],
                          value: 'id',
                          label: 'titulo',
                        }}
                        name="emailRespCliente"
                        defaultValue={mountedData?.enviaEmailSolicitante}
                      />
                    </Label>
                    <Label title="Data Inicio *" className="col s12 m6 l3">
                      <Input
                        type="date"
                        name="dataInicioProjeto"
                        required="true"
                        defaultValue={mountedData?.previsaoInicio}
                      />
                    </Label>
                    <Label title="Data Prev Entrega *" className="col s12 m6 l3">
                      <Input
                        type="date"
                        name="dataPrevEntregaProjeto"
                        required="true"
                        defaultValue={mountedData?.previsaoEntrega}
                      />
                    </Label>
                    <Label title="Ativo *" className="col s12 m6 l3">
                      <Select
                        required="true"
                        isString
                        list={{
                          list: [
                            { id: 'true', titulo: 'Sim' },
                            { id: 'false', titulo: 'Não' },
                          ],
                          value: 'id',
                          label: 'titulo',
                        }}
                        name="ativo"
                        defaultValue={mountedData?.ativo?.toString()}
                        onChange={e => {
                          const v = e.currentTarget.value || 'true';
                          setAtivo(v);
                        }}
                      />
                    </Label>
                  </div>
                  <div className="row no-margin">
                    <Label title="Tipo Projeto*" className="col s12 m6 l4">
                      <Select
                        required="true"
                        isString
                        list={{
                          list: [
                            { id: 'S', titulo: 'Suporte' },
                            { id: 'B', titulo: 'Banco de Horas' },
                            { id: 'P', titulo: 'Projeto' },
                            { id: 'A', titulo: 'Avulso' },
                          ],
                          value: 'id',
                          label: 'titulo',
                        }}
                        name="tipoProjeto"
                        firstOption
                        defaultValue={mountedData?.tipoProjeto}
                      />
                    </Label>
                    <Label title="Aprovador 1 *" className="col s12 m6 l4">
                      <Select
                        required="true"
                        isString
                        list={{ list: coordenadores, value: 'id', label: 'nome' }}
                        name="idCoordenador"
                        firstOption
                        defaultValue={mountedData?.idCoordenador}
                      />
                    </Label>
                    <Label title="Aprovador 2" className="col s12 m6 l4">
                      <Select
                        isString
                        list={{ list: coordenadores, value: 'id', label: 'nome' }}
                        name="idCoordenadorTec"
                        firstOption
                        defaultValue={mountedData?.idCoordenadorTec}
                      />
                    </Label>
                    {/* <Label title="Aprovador 1 *" className="col s12 m6 l3">
                        <Select
                          required="true"
                          isString
                          list={{ list: coordenadores, value: "id", label: "nome" }}
                          name="idCoordenador"
                          firstOption
                          defaultValue={mountedData?.idCoordenador}
                        />
                      </Label> */}
                    {/* <Label title="Hora Lib *" className="col s12 m6 l3">
                        <Input
                          type="number"
                          name="horaSaldo"
                          required="true"
                          disabled="true"
                          min="1"
                          value={horaSaldo}
                        />
                      </Label>
                      <Label title="Hora Total *" className="col s12 m6 l3">
                        <Input
                          type="number"
                          name="horaTotal"
                          required="true"
                          disabled="true"
                          min="1"
                          value={horaTotal}
                        />
                      </Label>
                      <Label title="Valor Hora" className="col s12 m6 l3">
                        <Input type="number" name="valorHora" required="false" defaultValue={mountedData?.valorHora} />
                      </Label>
                      <Label title="Valor Total *" className="col s12 m6 l3">
                        <Input type="number" name="valorTotal" min="1" required="true" defaultValue={mountedData?.valorTotal} />
                      </Label> */}
                  </div>
                  <div className="row no-margin">
                    <div className="col s12 m12 l12">
                      <RecursosList
                        setter={setRecursos}
                        defaultData={
                          typeof mountedData?.recurso == 'object'
                            ? mountedData?.recurso || []
                            : JSON.parse(mountedData?.recurso)
                        }
                      />
                    </div>
                  </div>
                </div>
              </div>
              <div className="row no-margin">
                <Label title="Anexo 1" className="col s12 m6 l3">
                  <ColoredFileInput
                    name="anexo1"
                    defaultFile={mountedData?.anexo1}
                    formFile={setFile1}
                    onDefaultFileRemove={e => e?.id && setRemoveArquivos(prev => [...prev, e?.id])}
                  />
                </Label>
                <Label title="Anexo 2" className="col s12 m6 l3">
                  <ColoredFileInput
                    name="anexo2"
                    defaultFile={mountedData?.anexo2}
                    formFile={setFile2}
                    onDefaultFileRemove={e => e?.id && setRemoveArquivos(prev => [...prev, e?.id])}
                  />
                </Label>
                <Label title="Anexo 3" className="col s12 m6 l3">
                  <ColoredFileInput
                    name="anexo3"
                    defaultFile={mountedData?.anexo3}
                    formFile={setFile3}
                    onDefaultFileRemove={e => e?.id && setRemoveArquivos(prev => [...prev, e?.id])}
                  />
                </Label>
                <Label title="Anexo 4" className="col s12 m6 l3">
                  <ColoredFileInput
                    name="anexo4"
                    defaultFile={mountedData?.anexo4}
                    formFile={setFile4}
                    onDefaultFileRemove={e => e?.id && setRemoveArquivos(prev => [...prev, e?.id])}
                  />
                </Label>
              </div>
            </div>
            <div className={abaAtiva == 1 ? 'item-modal ativo' : ' item-modal'}>
              <div>
                <div
                  style={{
                    display: 'flex',
                    gap: '16px',
                  }}
                >
                  <StatusCard
                    title="Receita Bruta"
                    value={`R$ ${valorTotalBruto.toLocaleString('pt-BR', {
                      minimumFractionDigits: 2,
                      maximumFractionDigits: 2,
                    })}`}
                    icon="paid"
                    color={Colors.Color4}
                    loading={false}
                    styleContainer={{ marginBottom: '16px' }}
                  />
                  <StatusCard
                    title="Imposto"
                    value={`R$ ${parseFloat(valorImposto || 0).toLocaleString('pt-BR', {
                      minimumFractionDigits: 2,
                      maximumFractionDigits: 2,
                    })}`}
                    icon="account_balance"
                    color={Colors.Color4}
                    loading={false}
                    styleContainer={{ marginBottom: '16px' }}
                  />
                  <StatusCard
                    title="Receita líquida"
                    value={`R$ ${valorTotalLiquido.toLocaleString('pt-BR', {
                      minimumFractionDigits: 2,
                      maximumFractionDigits: 2,
                    })}`}
                    icon="trending_up"
                    color={Colors.Color4}
                    loading={false}
                    styleContainer={{ marginBottom: '16px' }}
                  />
                  <StatusCard
                    title="Margem Lucro"
                    value={`R$ ${parseFloat(margemLucro || 0).toLocaleString('pt-BR', {
                      minimumFractionDigits: 2,
                      maximumFractionDigits: 2,
                    })}`}
                    icon="percent"
                    color={Colors.Color4}
                    loading={false}
                    styleContainer={{ marginBottom: '16px' }}
                  />
                  <StatusCard
                    title="Estimativa M.O"
                    value={`R$ ${valorMaoObra.toLocaleString('pt-BR', {
                      minimumFractionDigits: 2,
                      maximumFractionDigits: 2,
                    })}`}
                    icon="engineering"
                    color={Colors.Color4}
                    loading={false}
                    styleContainer={{ marginBottom: '16px' }}
                  />
                </div>

                <CardContainerInput>
                  <h3
                    style={{
                      fontSize: '1.2em',
                      fontWeight: 'bold',
                      marginBottom: '20px',
                      color: Colors.text_Color_1,
                      textAlign: 'center',
                    }}
                  >
                    Parâmetros de Cálculo
                  </h3>

                  <div
                    style={{
                      display: 'flex',
                      width: '100%',
                      justifyContent: 'space-between',
                      gap: '16px',
                    }}
                  >
                    <Label title="Hora Levantamento *" className="col s12 m6 l6">
                      <Input
                        type="number"
                        name="horaLevantamento"
                        required="true"
                        min="1"
                        value={horaLevantamento}
                        onChange={e => {
                          const v = e.currentTarget.value || 0;
                          setHoraLevantamento(v);
                          setValorTotalBruto(valorHoraBruto * v);
                          setValorHoraLiquido(
                            valorHoraBruto - valorHoraBruto * (percentualImposto / 100),
                          );

                          let valorHTLiquido = parseFloat(
                            (
                              (valorHoraBruto - valorHoraBruto * (percentualImposto / 100)) *
                              v
                            ).toFixed(2),
                          );
                          setValorTotalLiquido(valorHTLiquido);
                          setMargemLucro(
                            parseFloat(valorHTLiquido * (percentualLucro / 100)).toFixed(2),
                          );
                          setValorOrcamento(
                            parseFloat(valorHTLiquido * ((100 - percentualLucro) / 100)).toFixed(2),
                          );

                          let horasPreDev = parseFloat(
                            (
                              (valorHTLiquido * ((100 - percentualLucro) / 100)) /
                              valorMediaAna
                            ).toFixed(0),
                          );
                          setHorasPrevistaDev(horasPreDev);
                          setHorasGP(parseFloat((horasPreDev * (percentualGP / 100)).toFixed(0)));
                          setHorasDev(
                            parseFloat(
                              (horasPreDev - horasPreDev * (percentualGP / 100)).toFixed(0),
                            ),
                          );
                        }}
                      />
                    </Label>

                    <Label title="% Imposto" className="col s12 m6 l6">
                      <Input
                        type="number"
                        name="percentualImposto"
                        min="1"
                        required="true"
                        value={percentualImposto}
                        onChange={e => {
                          const v = e.currentTarget.value || 0;
                          setPercentualImposto(v);
                          setValorHoraLiquido(valorHoraBruto - valorHoraBruto * (v / 100));
                          setValorImposto((valorTotalBruto * (v / 100)).toFixed(2));

                          let valorHTLiquido = valorTotalBruto - valorTotalBruto * (v / 100);
                          setValorTotalLiquido(valorHTLiquido);
                          setMargemLucro(
                            parseFloat(valorHTLiquido * (percentualLucro / 100)).toFixed(2),
                          );
                          setValorOrcamento(
                            parseFloat(valorHTLiquido * ((100 - percentualLucro) / 100)).toFixed(2),
                          );

                          let horasPreDev = parseFloat((valorHTLiquido / valorMediaAna).toFixed(0));
                          setHorasPrevistaDev(horasPreDev);
                          setHorasGP(parseFloat((horasPreDev * (percentualGP / 100)).toFixed(0)));
                          setHorasDev(
                            parseFloat(
                              (horasPreDev - horasPreDev * (percentualGP / 100)).toFixed(0),
                            ),
                          );
                        }}
                      />
                    </Label>

                    <Label title="% Lucro" className="col s12 m6 l6">
                      <Input
                        type="number"
                        name="percentualLucro"
                        min="1"
                        max="100"
                        required="true"
                        value={percentualLucro}
                        onChange={e => {
                          const v = e.currentTarget.value || 0;
                          setPercentualLucro(v);
                          setMargemLucro(parseFloat(valorTotalLiquido * (v / 100)).toFixed(2));
                          setValorOrcamento(
                            parseFloat(valorTotalLiquido * ((100 - v) / 100)).toFixed(2),
                          );

                          let horasPreDev = parseFloat(
                            ((valorTotalLiquido * ((100 - v) / 100)) / valorMediaAna).toFixed(0),
                          );
                          setHorasPrevistaDev(horasPreDev);
                          setHorasGP(parseFloat((horasPreDev * (percentualGP / 100)).toFixed(0)));
                          setHorasDev(
                            parseFloat(
                              (horasPreDev - horasPreDev * (percentualGP / 100)).toFixed(0),
                            ),
                          );
                        }}
                      />
                    </Label>

                    <Label title="% Gestão Projeto *" className="col s12 m6 l6">
                      <Input
                        type="number"
                        name="percentualGP"
                        min="1"
                        required="true"
                        value={percentualGP}
                        onChange={e => {
                          const v = e.currentTarget.value || 0;
                          setPercentualGP(v);

                          setHorasGP(parseFloat((horasPrevistaDev * (v / 100)).toFixed(0)));
                          setHorasDev(
                            parseFloat(
                              (horasPrevistaDev - horasPrevistaDev * (v / 100)).toFixed(0),
                            ),
                          );
                        }}
                      />
                    </Label>
                  </div>
                </CardContainerInput>

                <CardContainerInput
                  style={{
                    marginTop: '16px',
                  }}
                >
                  <p
                    style={{
                      fontSize: '1em',
                      fontWeight: 'bold',
                      marginBottom: '16px',
                      color: 'white',
                    }}
                  >
                    Distribuição Prevista de Custos e Horas
                  </p>

                  <div
                    style={{
                      width: '100%',
                      display: 'flex',
                      gap: '32px',
                    }}
                  >
                    <div
                      style={{
                        borderRadius: '8px',
                        width: '100%',
                      }}
                    >
                      <div
                        style={{
                          display: 'flex',
                          flexDirection: 'column',
                          gap: '8px',
                        }}
                      >
                        <div
                          style={{
                            display: 'grid',
                            gridTemplateColumns: 'repeat(2, 1fr)',
                            gap: '16px',
                          }}
                        >
                          <Label title="Porcentagem Mão de Obra *">
                            <Input
                              type="number"
                              name="percentualMaoObra"
                              required="true"
                              step="1"
                              min="0"
                              max="100"
                              value={percentualMaoObra * 100}
                              onChange={e => {
                                const formatValue = parseFloat(e.currentTarget.value) / 100;
                                const v = formatValue || 0;
                                setPercentualMaoObra(v);
                              }}
                            />
                          </Label>

                          <Label title="Valor Hora Nível 1 *">
                            <Input
                              type="number"
                              name="valorNivel1"
                              required="true"
                              step="0.01"
                              value={valorNivel1}
                              onChange={e => {
                                const v = parseFloat(e.currentTarget.value) || 0;
                                setValorNivel1(v);
                              }}
                            />
                          </Label>
                        </div>
                        <div
                          style={{
                            display: 'grid',
                            gridTemplateColumns: 'repeat(2, 1fr)',
                            gap: '16px',
                          }}
                        >
                          <Label title="Valor Hora Nível 2 *">
                            <Input
                              type="number"
                              name="valorNivel2"
                              required="true"
                              step="0.01"
                              value={valorNivel2}
                              onChange={e => {
                                const v = parseFloat(e.currentTarget.value) || 0;
                                setValorNivel2(v);
                              }}
                            />
                          </Label>
                          <Label title="Valor Hora Nível 3 *">
                            <Input
                              type="number"
                              name="valorNivel3"
                              required="true"
                              step="0.01"
                              value={valorNivel3}
                              onChange={e => {
                                const v = parseFloat(e.currentTarget.value) || 0;
                                setValorNivel3(v);
                              }}
                            />
                          </Label>
                          <Label title="Horas Coordenação *">
                            <Input
                              type="number"
                              name="horasCoordenacao"
                              required="true"
                              min="0"
                              value={horasCoordenacao}
                              onChange={e => {
                                const v = parseFloat(e.currentTarget.value) || 0;
                                setHorasCoordenacao(v);
                              }}
                            />
                          </Label>
                          <Label title="Valor Hora Coordenação *">
                            <Input
                              type="number"
                              name="valorCoordenacao"
                              required="true"
                              step="0.01"
                              value={valorCoordenacao}
                              onChange={e => {
                                const v = parseFloat(e.currentTarget.value) || 0;
                                setValorCoordenacao(v);
                              }}
                            />
                          </Label>
                        </div>

                        <div
                          style={{
                            display: 'flex',
                            justifyContent: 'space-between',
                            alignItems: 'center',
                          }}
                        >
                          <h4
                            style={{
                              fontSize: '0.8em',
                              fontWeight: 'bold',
                            }}
                          >
                            Valor para Mão de Obra
                          </h4>
                          <span
                            style={{
                              fontSize: '0.76em',
                              fontWeight: '400',
                              color: Colors.Color4,
                            }}
                          >
                            R${' '}
                            {valorMaoObra.toLocaleString('pt-BR', {
                              minimumFractionDigits: 2,
                              maximumFractionDigits: 2,
                            })}
                          </span>
                        </div>
                        <div
                          style={{
                            display: 'flex',
                            justifyContent: 'space-between',
                            alignItems: 'center',
                          }}
                        >
                          <div style={{ display: 'flex', alignItems: 'center' }}>
                            <h4
                              style={{
                                fontSize: '0.8em',
                                fontWeight: 'bold',
                              }}
                            >
                              Valor Líquido para Níveis
                            </h4>
                            <Tooltip content="Valor restante da mão de obra após subtrair o custo da coordenação." />
                          </div>
                          <span
                            style={{
                              fontSize: '0.76em',
                              fontWeight: '400',
                              color: Colors.Color4,
                            }}
                          >
                            R${' '}
                            {valorAposCoordenacao.toLocaleString('pt-BR', {
                              minimumFractionDigits: 2,
                              maximumFractionDigits: 2,
                            })}
                          </span>
                        </div>
                      </div>
                    </div>

                    <div style={{ borderRadius: '8px', width: '100%' }}>
                      <div>
                        <div
                          style={{
                            display: 'flex',
                            flexDirection: 'column',
                            gap: '20px',
                          }}
                        >
                          <NivelCard nivel="Nível 1" valorHora={valorNivel1} horas={horasNivel1} />
                          <NivelCard nivel="Nível 2" valorHora={valorNivel2} horas={horasNivel2} />
                          <NivelCard nivel="Nível 3" valorHora={valorNivel3} horas={horasNivel3} />
                          <NivelCard
                            nivel="Coordenação"
                            valorHora={valorCoordenacao}
                            horas={horasCoordenacao}
                            valorTotal={valorCoordenacao * horasCoordenacao}
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </CardContainerInput>
              </div>
            </div>
            <div className={abaAtiva == 2 ? 'item-modal ativo' : 'item-modal'}>
              <div
                style={{
                  display: 'flex',
                  gap: '16px',
                }}
              >
                <StatusCard
                  title="Custo Total Real"
                  subtitle={`Previsto: R$ ${(
                    valorMaoObra + parseFloat(valorImposto || 0)
                  ).toLocaleString('pt-BR', {
                    minimumFractionDigits: 2,
                    maximumFractionDigits: 2,
                  })}`}
                  color={Colors.Color4}
                  value={`R$ ${(
                    analistasConsolidados.reduce((acc, a) => acc + a.custo, 0) +
                    parseFloat(valorImposto || 0)
                  ).toLocaleString('pt-BR', {
                    minimumFractionDigits: 2,
                    maximumFractionDigits: 2,
                  })}`}
                  icon="paid"
                  // color={Colors.ftCard1}
                  loading={false}
                  styleContainer={{ marginBottom: '16px' }}
                />
                <StatusCard
                  title="Lucro Real"
                  subtitle={`Previsto: R$ ${parseFloat(margemLucro || 0).toLocaleString('pt-BR', {
                    minimumFractionDigits: 2,
                    maximumFractionDigits: 2,
                  })}`}
                  color={Colors.Color4}
                  value={`R$ ${(
                    valorTotalBruto -
                    parseFloat(valorImposto || 0) -
                    analistasConsolidados.reduce((acc, a) => acc + a.custo, 0)
                  ).toLocaleString('pt-BR', {
                    minimumFractionDigits: 2,
                    maximumFractionDigits: 2,
                  })}`}
                  icon="trending_up"
                  loading={false}
                  styleContainer={{ marginBottom: '16px' }}
                />
                <StatusCard
                  title="Margem Real"
                  subtitle={`Previsto: ${percentualLucro > 0 ? percentualLucro : 0}%`}
                  color={Colors.Color4}
                  value={`${(
                    ((valorTotalBruto -
                      parseFloat(valorImposto || 0) -
                      analistasConsolidados.reduce((acc, a) => acc + a.custo, 0)) /
                      valorTotalBruto) *
                    100
                  ).toFixed(2)}%`}
                  icon="percent"
                  loading={false}
                  styleContainer={{ marginBottom: '16px' }}
                />
                <StatusCard
                  title="Horas Totais Reais"
                  subtitle={`Previsto: ${horaLevantamento}h`}
                  color={Colors.Color4}
                  value={mountedData?.totalHorasProjetoMascara ?? '00:00'}
                  icon="schedule"
                  loading={false}
                  styleContainer={{ marginBottom: '16px' }}
                />
              </div>

              <div
                style={{
                  display: 'flex',
                  justifyContent: 'space-between',
                  width: '100%',
                  gap: '16px',
                }}
              >
                <FinanceResultContainer
                  style={{
                    display: 'flex',
                    flexDirection: 'column',
                    width: '100%',
                  }}
                >
                  <h3
                    style={{
                      fontSize: '1.2em',
                      fontWeight: 'bold',
                      marginBottom: '20px',
                      color: Colors.text_Color_1,
                      display: 'flex',
                      alignItems: 'center',
                      gap: '8px',
                    }}
                  >
                    <span className="material-icons" style={{ fontSize: '1.2em' }}>
                      assessment
                    </span>
                    Resultado Financeiro do Projeto
                  </h3>

                  <div
                    style={{
                      display: 'grid',
                      gridTemplateColumns: '1fr 1fr',
                      rowGap: '32px',
                      columnGap: '32px',
                    }}
                  >
                    <div
                      style={{
                        display: 'flex',
                        flexDirection: 'column',
                        alignItems: 'center',
                      }}
                    >
                      <p
                        style={{
                          fontSize: '0.8em',
                          fontWeight: '600',
                        }}
                      >
                        Receita Bruta
                      </p>

                      <span
                        style={{
                          color: Colors.Color4,
                          fontWeight: 'bold',
                          fontSize: '1.1em',
                        }}
                      >
                        R${' '}
                        {valorTotalBruto.toLocaleString('pt-BR', {
                          minimumFractionDigits: 2,
                          maximumFractionDigits: 2,
                        })}
                      </span>
                    </div>

                    <div
                      style={{
                        display: 'flex',
                        flexDirection: 'column',
                        alignItems: 'center',
                      }}
                    >
                      <p
                        style={{
                          fontSize: '0.8em',
                          fontWeight: '600',
                        }}
                      >
                        (-) Custos M.O
                      </p>

                      <span
                        style={{
                          color: Colors.ft_color_10,
                          fontWeight: 'bold',
                          fontSize: '1.1em',
                        }}
                      >
                        R${' '}
                        {analistasConsolidados
                          .reduce((acc, a) => acc + a.custo, 0)
                          .toLocaleString('pt-BR', {
                            minimumFractionDigits: 2,
                            maximumFractionDigits: 2,
                          })}
                      </span>
                      <span
                        style={{
                          color: Colors.Color7,
                          fontSize: '0.56em',
                          opacity: 0.8,
                          fontWeight: '400',
                        }}
                      >
                        Previsto: R${' '}
                        {valorMaoObra.toLocaleString('pt-BR', {
                          minimumFractionDigits: 2,
                          maximumFractionDigits: 2,
                        })}
                      </span>
                    </div>

                    <div
                      style={{
                        display: 'flex',
                        flexDirection: 'column',
                        // gap: '8px',
                        alignItems: 'center',
                      }}
                    >
                      <p
                        style={{
                          fontSize: '0.8em',
                          fontWeight: '600',
                        }}
                      >
                        (-) Imposto ({percentualImposto > 0 ? percentualImposto : 0}
                        %)
                      </p>

                      <span
                        style={{
                          color: Colors.ft_color_10,
                          fontWeight: 'bold',
                          fontSize: '1.1em',
                        }}
                      >
                        R${' '}
                        {parseFloat(valorImposto || 0).toLocaleString('pt-BR', {
                          minimumFractionDigits: 2,
                          maximumFractionDigits: 2,
                        })}
                      </span>
                      <span
                        style={{
                          color: Colors.Color7,
                          fontSize: '0.56em',
                          opacity: 0.8,
                          fontWeight: '400',
                        }}
                      >
                        Previsto: R${' '}
                        {parseFloat(valorImposto || 0).toLocaleString('pt-BR', {
                          minimumFractionDigits: 2,
                          maximumFractionDigits: 2,
                        })}
                      </span>
                    </div>

                    <div
                      style={{
                        display: 'flex',
                        flexDirection: 'column',
                        // gap: '8px',
                        alignItems: 'center',
                      }}
                    >
                      <p
                        style={{
                          fontSize: '0.8em',
                          fontWeight: '600',
                        }}
                      >
                        (=) Lucro Líquido
                      </p>

                      <span
                        style={{
                          color:
                            valorTotalBruto -
                              parseFloat(valorImposto || 0) -
                              analistasConsolidados.reduce((acc, a) => acc + a.custo, 0) >=
                            0
                              ? Colors.ft_color_8
                              : Colors.ft_color_10,
                          fontWeight: 'bold',
                          fontSize: '1.1em',
                        }}
                      >
                        R${' '}
                        {(
                          valorTotalBruto -
                          parseFloat(valorImposto || 0) -
                          analistasConsolidados.reduce((acc, a) => acc + a.custo, 0)
                        ).toLocaleString('pt-BR', {
                          minimumFractionDigits: 2,
                          maximumFractionDigits: 2,
                        })}
                      </span>
                      <span
                        style={{
                          color: Colors.Color7,
                          // fontSize: '0.75em',
                          fontSize: '0.56em',
                          opacity: 0.8,
                          fontWeight: '400',
                        }}
                      >
                        Previsto: R${' '}
                        {parseFloat(margemLucro || 0).toLocaleString('pt-BR', {
                          minimumFractionDigits: 2,
                          maximumFractionDigits: 2,
                        })}
                      </span>
                    </div>
                  </div>
                </FinanceResultContainer>

                <div
                  style={{
                    // padding: '4px',
                    border: `1px solid ${Colors.Border_Color_1}`,
                    borderRadius: '8px',
                    width: '100%',
                    height: 'fit-content',
                    paddingTop: '16px',
                  }}
                >
                  <FinanceChart
                    previsto={{
                      custo: valorMaoObra + parseFloat(valorImposto || 0),
                      lucro: parseFloat(margemLucro || 0),
                      horas: horaLevantamento,
                    }}
                    real={{
                      custo:
                        analistasConsolidados.reduce((acc, a) => acc + a.custo, 0) +
                        parseFloat(valorImposto || 0),
                      lucro:
                        valorTotalBruto -
                        parseFloat(valorImposto || 0) -
                        analistasConsolidados.reduce((acc, a) => acc + a.custo, 0),
                      horas: analistasConsolidados.reduce((acc, a) => acc + a.horasDecimal, 0),
                    }}
                  />
                </div>
              </div>

              <AnalistasTable>
                <AnalistasTableHeader>
                  <div>Analista</div>
                  <div>Nível</div>
                  <div>Valor Hora</div>
                  <div>Horas Usadas</div>
                  <div>Custo</div>
                </AnalistasTableHeader>

                {analistasConsolidados.length > 0 ? (
                  analistasConsolidados.map((analista, index) => (
                    <AnalistasTableBody
                      key={analista.idAnalista}
                      hasBorder={index < analistasConsolidados.length - 1}
                    >
                      <div
                        style={{
                          fontSize: '0.875rem',
                          fontWeight: '600',
                        }}
                      >
                        {analista.nomeAnalista}
                      </div>
                      <div>{analista.nivel}</div>
                      <div>
                        R${' '}
                        {analista.valorHora.toLocaleString('pt-BR', {
                          minimumFractionDigits: 2,
                          maximumFractionDigits: 2,
                        })}
                      </div>
                      <div>{analista.horaUsadaMascara}</div>
                      <div
                        style={{
                          color: Colors.Color4,
                          fontWeight: 500,
                        }}
                      >
                        R${' '}
                        {analista.custo.toLocaleString('pt-BR', {
                          minimumFractionDigits: 2,
                          maximumFractionDigits: 2,
                        })}
                      </div>
                    </AnalistasTableBody>
                  ))
                ) : (
                  <AnalistasTableBody>
                    <div colSpan="5" style={{ textAlign: 'center', gridColumn: '1 / -1' }}>
                      {mountedData?.atividades && mountedData.atividades.length > 0
                        ? 'Nenhum analista com horas registradas'
                        : 'Nenhuma atividade disponível'}
                    </div>
                  </AnalistasTableBody>
                )}
              </AnalistasTable>
            </div>{' '}
            <div className={abaAtiva == 3 ? 'item-modal ativo' : 'item-modal'}>
              <div className="row no-margin">
                <div className="col s12 m12 l12">
                  <AtividadesList
                    setter={setAtividades}
                    defaultData={mountedData?.atividades || []}
                    setterSoma={setHoraTotal}
                    setterSomaLib={setHoraSaldo}
                    gerarProjeto={true}
                  />
                </div>
              </div>
            </div>
            <div className={abaAtiva == 4 ? 'item-modal ativo' : 'item-modal'}>
              <div className="row no-margin">
                <div className="col s12 m12 l12">
                  <AcessosList setter={setAcessos} defaultData={mountedData?.acessos || []} />
                </div>
              </div>
            </div>
          </div>
        )}
      </Materialize>
      <div className="footer">
        <Label title="Etapa *" className="no-margin" row={true}>
          <Select
            required="true"
            isString
            list={{ list: etapas, value: 'id', label: 'titulo' }}
            name="idEtapa"
            defaultValue={idEtapa}
            onChange={e => {
              const v = e.currentTarget.value || 0;
              setIdEtapa(parseInt(v));

              const item = etapas.find(data => data?.id === parseInt(v));
              setGerarProjeto(item?.final == 'S' ? true : false);
            }}
          />
        </Label>
        <PrioridadeListColor
          name="idPrioridade"
          setter={setPrioridade}
          defaultData={mountedData?.prioridade}
        />
      </div>
    </Container>
  );
}

export default CreateEditContent;

const NivelCard = ({ nivel, valorHora, horas, valorTotal }) => {
  return (
    <div
      style={{
        backgroundColor: Colors.bgCardColor,
        border: `1px solid ${Colors.Border_Color_1}`,
        borderRadius: '8px',
        paddingBlock: '8px',
        paddingInline: '16px',
      }}
    >
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
        <div>
          <h4
            style={{
              margin: 0,
              fontSize: '0.8em',
              fontWeight: 'bold',
            }}
          >
            {nivel}
          </h4>

          <span
            style={{
              fontSize: '0.7em',
              fontWeight: '500',
            }}
          >
            R${' '}
            {valorHora.toLocaleString('pt-BR', {
              minimumFractionDigits: 2,
              maximumFractionDigits: 2,
            })}
            /hora
          </span>
        </div>
        <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-end' }}>
          <span
            style={{
              fontSize: '0.8em',
              fontWeight: 'bold',
              color: Colors.Color4,
            }}
          >
            {horas}h
          </span>

          {valorTotal && (
            <span
              style={{
                fontSize: '0.7em',
                fontWeight: '500',
                color: Colors.Color4,
              }}
            >
              {valorTotal.toLocaleString('pt-BR', {
                style: 'currency',
                currency: 'BRL',
                minimumFractionDigits: 2,
                maximumFractionDigits: 2,
              })}
            </span>
          )}
        </div>
      </div>
    </div>
  );
};
